var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    transform: "rotate(-180 15 15)",
    fill: "currentColor",
    stroke: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.54135L17.8462 14.4812L12.0385 20.4962L13.5385 22L21 14.5564L13.6154 7L12 8.54135Z",
    fill: "#4D5154"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/nextIcon.0a6232ad878f8748df9258ab9372210c.svg";
export { ForwardRef as ReactComponent };